import { SafeJSON } from './../../shared/safe-json';
import { Parent } from './../juvenile-case-sections/parent';
import { OtherAllegation } from './../juvenile-case-sections/other-allegations';

export class DispositionDelinquentOffense {
    private json: any;
    private caseIssueId: string;
    private parents: any = [];
    private otherAllegations: any = [];

    constructor(json: any, caseIssueId: string) {
        this.json = json;
        this.caseIssueId = caseIssueId;
        this.populateParents();
        this.populateOtherAllegations();
    }

    populateParents() {
        let obj: any = SafeJSON.get('parents', this.json);
        let index = '0';
        for (const party of obj) {
            let value = new Parent(party, index);
            this.parents.push(value);
        }
    }

    getParents(): any[] {
        this.parents.sort(function (parent1, parent2) {
            return parent1.getPartyName() === parent2.getPartyName() ? 0 : parent1.getPartyName() < parent2.getPartyName() ? -1 : 1;
        });
        return this.parents;
    }

    populateOtherAllegations() {
        let obj: any = SafeJSON.get('allegations', this.json);
        for (const otherAllegation of obj) {
            let allegationId: string = SafeJSON.get('allegationId', otherAllegation);
            if (allegationId !== this.caseIssueId) {
                let value = new OtherAllegation(otherAllegation);
                this.otherAllegations.push(value);
            }
        }
    }


    getOtherAllegations(): any[] {
        return this.otherAllegations;
    }

    getDispositionDate(): string {
        return SafeJSON.get('dispositionDate', this.json);
    }

    getDispositionEoDate(): string {
        return SafeJSON.get('orderFileDate', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/disposition-delinquent-offense.ts